<template>
  <px-custom-dialog v-model="dialog"
                    content-class="rounded-card"
                    :width="dialogWidth">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
        <v-btn icon
               v-on="on">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </slot>
    </template>
    <template v-slot:title>
      Aprovação de solicitação
    </template>
    <template>
      <px-aprovacao-solicitacao-detalhes is-modal-view
                                         :aprovacao-id-prop="aprovacaoId"
                                         @update="onUpdate"/>
    </template>
  </px-custom-dialog>
</template>

<script>
import AprovacaoSolicitacaoDetalhes
  from '@/modules/aprovacao-solicitacao/detalhes/AprovacaoSolicitacaoDetalhes.vue';

export default {
  props: {
    aprovacaoId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    isSmall() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    dialogWidth() {
      return this.isSmall ? '95%' : '1400px';
    },
  },
  methods: {
    open() {
      this.dialog = true;
    },
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoSolicitacaoDetalhes: AprovacaoSolicitacaoDetalhes,
  },
};
</script>
